import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import {
  BUTTON_BOLD,
  BUTTON_ITALIC,
  BUTTON_BLOCKQUOTE,
  BUTTON_LINK,
  BUTTON_HEADER_DROPDOWN,
  BUTTON_LIST_DROPDOWN,
  BUTTON_ALIGN_TEXT_DROPDOWN,
  BUTTON_IMAGE,
  BUTTON_VIDEO,
} from './constants/buttons';
import { HorizontalSeparator } from '../separator';
import TextEditorButtonGroup from './text-editor-button-group';
import styles from './text-editor-mobile-toolbar.scss';

const BUTTONS_LEFT = [
  BUTTON_BOLD,
  BUTTON_ITALIC,
  BUTTON_HEADER_DROPDOWN,
  BUTTON_ALIGN_TEXT_DROPDOWN,
  BUTTON_LIST_DROPDOWN,
  BUTTON_BLOCKQUOTE,
  BUTTON_LINK,
];
const BUTTONS_RIGHT = [BUTTON_IMAGE, BUTTON_VIDEO];

const TextEditorMobileToolbar = ({ identifier, theme }) => (
  <div
    className={classNames(get(theme, 'container'), 'text-editor-mobile-toolbar')}
    style={get(theme, 'containerStyle')}
  >
    <div className={styles.flexContainer}>
      {renderGroup(BUTTONS_LEFT, identifier, true, get(theme, 'button'))}
      {renderGroup(BUTTONS_RIGHT, identifier, false, get(theme, 'button'))}
    </div>
    <HorizontalSeparator/>
  </div>
);

function renderGroup(buttons, identifier, disableOnBlur, theme) {
  return (
    <TextEditorButtonGroup
      buttons={buttons}
      identifier={identifier}
      containerClassName={styles.buttons}
      buttonClassName={styles.button}
      disableOnBlur={disableOnBlur}
      theme={theme}
    />
  );
}

TextEditorMobileToolbar.propTypes = {
  identifier: PropTypes.string.isRequired,
  theme: PropTypes.object,
};

export default TextEditorMobileToolbar;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-mobile-toolbar.js